"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M31.7 4.3a7.176 7.176 0 0 0-10.148 0c-.385.385-4.264 4.222-5.351 5.309a8.308 8.308 0 0 1 3.742.607c.52-.52 3.568-3.526 3.783-3.741a4.1 4.1 0 1 1 5.8 5.8l-7.118 7.115a4.623 4.623 0 0 1-3.372 1.3 3.953 3.953 0 0 1-2.7-1.109 4.161 4.161 0 0 1-1.241-1.625 2.026 2.026 0 0 0-.427.318l-1.636 1.712a7.134 7.134 0 0 0 1.227 1.673c2.8 2.8 7.874 2.364 10.676-.438l6.765-6.769a7.176 7.176 0 0 0 0-10.152z" }),
  React.createElement("path", { d: "M15.926 25.824c-.52.52-3.5 3.547-3.713 3.761a4.1 4.1 0 0 1-5.8-5.8L13.6 16.6a4.584 4.584 0 0 1 3.367-1.293 4.2 4.2 0 0 1 3.783 2.783 2.026 2.026 0 0 0 .427-.318l1.735-1.721a7.134 7.134 0 0 0-1.227-1.673 7.311 7.311 0 0 0-10.26.047l-7.186 7.187a7.176 7.176 0 0 0 10.148 10.149c.385-.385 4.194-4.242 5.281-5.329a8.308 8.308 0 0 1-3.742-.608z" })
);

